import { render, staticRenderFns } from "./AdminActionConfirmModal.vue?vue&type=template&id=16c536de&"
import script from "./AdminActionConfirmModal.vue?vue&type=script&lang=js&"
export * from "./AdminActionConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports